import { useEffect } from 'react';

import { useImpState } from '../../app/hooks';
import { ApplicationLoader } from '../../components/ApplicationLoader/ApplicationLoader';
import { merchantInfoByProductUUID } from '../../utils/productUUIDConstants';
import { PAGE } from '../../utils/routeConstant';

export default function ApplicationLandingPage() {
  const { merchantData } = useImpState();

  useEffect(() => {
    if (merchantData.productUUID) {
      navigateToApplication();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantData.productUUID]);

  const navigateToApplication = () => {
    const applicationPath =
      merchantInfoByProductUUID[merchantData.productUUID]?.pageToNavigate ||
      PAGE.HOME;
    window.location.pathname = applicationPath;
  };

  return <ApplicationLoader />;
}
